import { Ribbon, IRibbon } from "./Ribbon";
import { ScrollView } from "@dhx/ts-common/ScrollView";
import { el } from "@dhx/ts-common/dom";
import { locateNode } from "@dhx/ts-common/html";
import { tooltip, Position } from "@dhx/ts-message";

export interface IProRibbon extends IRibbon {
	scrollView: ScrollView;
}

export class ProRibbon extends Ribbon implements IProRibbon {
	scrollView: ScrollView;

	constructor(element?: string | HTMLElement, config?) {
		super(element, config);
		this.scrollView = new ScrollView(() => this.getRootView());
	}

	protected _draw() {
		this._heightCalculate();

		const navBar = [
			el(
				"ul.dhx_ribbon-content.dhx_ribbon-content--full-width",
				{
					style: { height: Math.max(...this._widgetHeight) },
				},
				this.data.map(
					block =>
						block.type === "block" ? this._drawBlock(block as any, true) : this._factory(block),
					this.data.getRoot(),
					false
				)
			),
		];

		const itemsHeight = Math.max(...this._widgetHeight);

		return el(
			"ul.dhx_ribbon.dhx_widget",
			{
				"data-dhx-widget-id": this._uid,
				class: this.config.css ? this.config.css : "",
				tabindex: 0,
				onclick: this._handlers.onclick,
				onmousedown: this._handlers.onmousedown,
				oninput: this._listeners.input,
				onmouseover: this._listeners.tooltip,
				_hooks: {
					didInsert: node => {
						node.el.addEventListener(
							"keyup",
							(e: KeyboardEvent) => {
								if (e.which !== 9) {
									return;
								}
								const elem = locateNode(document.activeElement);
								if (!elem) {
									return;
								}

								const id = elem.getAttribute("data-dhx-id");
								const item = this.data.getItem(id);
								if (item.tooltip) {
									tooltip(item.tooltip, {
										node: elem as HTMLElement,
										position: Position.bottom,
										force: true,
									});
								}
							},
							true
						);
					},
				},
			},
			[
				el(
					"li",
					{
						class: "dhx_ribbon-block dhx_ribbon-block--root",
						style: { height: this._haveTitle ? itemsHeight + 24 : itemsHeight },
					},
					this.scrollView && this.scrollView.config.enable
						? [].concat(this.scrollView.render(navBar))
						: navBar
				),
			]
		);
	}
}
